var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.7558,
    height: 20.5009,
    rx: 6.00032,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18412 15.501C9.40393 15.501 9.58212 15.2772 9.58212 15.001C9.58212 14.7248 9.40393 14.501 9.18412 14.501C8.96432 14.501 8.78613 14.7248 8.78613 15.001C8.78613 15.2772 8.96432 15.501 9.18412 15.501Z",
    stroke: "#404040",
    strokeWidth: 0.996054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5621 15.501C13.7819 15.501 13.96 15.2772 13.96 15.001C13.96 14.7248 13.7819 14.501 13.5621 14.501C13.3422 14.501 13.1641 14.7248 13.1641 15.001C13.1641 15.2772 13.3422 15.501 13.5621 15.501Z",
    stroke: "#404040",
    strokeWidth: 0.996054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5H7.59197L8.65859 11.6954C8.69498 11.9256 8.79466 12.1324 8.94019 12.2795C9.08571 12.4267 9.26779 12.5049 9.45457 12.5004H13.3231C13.5098 12.5049 13.6919 12.4267 13.8374 12.2795C13.983 12.1324 14.0826 11.9256 14.119 11.6954L14.7558 7.50014H7.98996",
    stroke: "#404040",
    strokeWidth: 0.996054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame1.070df5a893128e48643d00330a685c62.svg";
export { ForwardRef as ReactComponent };